export const API_ROOT = 'https://api.shrinkage-analysis.engineering.corp.lego.com/';
export const SHRINKAGE_ANALYSIS_URL = `${ API_ROOT }shrinkage-analysis`;
